// The waiting indicator's timing and labels (site-assistant SA24). The dots are a
// CSS loop that keeps running whether or not the server is alive, so the label
// changes with real events and a watchdog ends the wait.

import { AI_CHAT_TIMEOUT_SECONDS } from "@checklist/shared";

/** No stream event for this long switches the label to the "still working" message. */
export const STALL_MS = 15_000;
/** A margin past the chat Lambda's own timeout; past it the request is aborted and shown as an error. */
export const WATCHDOG_MS = (AI_CHAT_TIMEOUT_SECONDS + 15) * 1_000;

export const THINKING_LABEL = "Thinking…";
export const STALLED_LABEL = "Still working - this one is taking a little longer.";
export const WATCHDOG_MESSAGE = "The assistant took too long to answer. Please try again.";
const UNKNOWN_TOOL_LABEL = "Looking that up…";

/** One friendly label per tool; the raw tool name never reaches the screen. */
const TOOL_LABELS: Record<string, string> = {
  search_kb: "Searching the help notes…",
  read_kb_section: "Reading the help notes…",
  navigate_to: "Finding the right page…",
  draft_ticket: "Drafting a support ticket…",
  search_my_lists: "Looking through your lists…",
  search_community: "Searching community lists…",
  read_resource: "Reading that for you…",
  get_list_items: "Reading the list…",
};

export function toolLabel(name: string): string {
  const label = TOOL_LABELS[name];
  if (label) return label;
  if (name.startsWith("propose_")) return "Preparing a change for you to review…";
  return UNKNOWN_TOOL_LABEL;
}

/**
 * What the indicator says right now, or null when nothing should show. `pending`
 * is "a turn is in flight and nothing is visibly arriving": before the first
 * delta and during every tool round. Null while text streams - the growing text
 * is the progress signal - and when no turn is in flight.
 */
export function waitingLabel(pending: { tool: string | null } | null, stalled: boolean): string | null {
  if (!pending) return null;
  if (stalled) return STALLED_LABEL;
  return pending.tool ? toolLabel(pending.tool) : THINKING_LABEL;
}
